import React from 'react'

import { GameBoxes } from './GameBoxes'
import { GamesBaseGrid } from './styled/GamesBaseGrid'
import { GamesLimitedGrid } from './styled/GamesLimitedGrid'
import { GridGame } from './types'

interface Props {
  games: GridGame[]
  showAll?: boolean
  rows?: number
}

function GamesGrid({ games, rows = 2, showAll = false }: Props) {
  if (showAll) {
    return (
      <GamesBaseGrid>
        <GameBoxes games={games} />
      </GamesBaseGrid>
    )
  }

  return (
    <GamesLimitedGrid rows={rows}>
      <GameBoxes games={games} />
    </GamesLimitedGrid>
  )
}

export default GamesGrid
